import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Folder } from 'src/app/models/server/folder';

@Injectable({
    providedIn: 'root',
})
export class FolderCommentsStateService {
    private onFolderCommentChange = new BehaviorSubject<Folder>(null);

    /**
     * Emet un événement lorsqu'un commentaire de dossier change.
     */
    get onFolderCommentChange$() {
        return this.onFolderCommentChange.asObservable();
    }

    /**
     * Indique que le commentaire d'un dossier a été mis à jour.
     */
    public updateFolderComment(folder: Folder) {
        this.onFolderCommentChange.next(folder);
    }

    constructor() {}
}
